import * as Yup from 'yup'

const phoneNumberValidation = '^[0-9-() ]{10,11}$'
const nameValidation = /^[a-zA-Z]+( [a-zA-Z]+)+$/
const schema = Yup.object().shape({
  countryCode: Yup.string().required('Required'),
  phoneNumber: Yup.string()
    .required('Enter mobile phone numbe')
    .matches(phoneNumberValidation, 'Invalid Phone number e.g 3456789123'),
  name: Yup.string()
    .required('First and last names is required')
    .matches(nameValidation, 'First and last names are required e.g John Doe'),
  email: Yup.string().required('Email is required').email('Email is invalid'),
  roles: Yup.array().min(1, 'At least one role is required'),
})

const organizationRoleValidation = {
  async validator({ field }, value) {
    await schema.validateSyncAt(field, { [field]: value })
  },
}

export { organizationRoleValidation }
